"use client";

import { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/shadcn/ui/dropdown-menu";

import menu from "@/public/shop/menu.svg";
import x from "@/public/shop/x.svg";

export default function MobileMenu({
  theme,
}: {
  theme: "light" | "transparent";
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="lg:hidden">
      <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
        <DropdownMenuTrigger asChild>
          <button className="group h-full p-[2rem] hover:bg-white transition-colors outline-none ring-0">
            <Image
              src={isOpen ? x : menu}
              alt="Menü"
              className={
                theme === "transparent"
                  ? "w-[3rem] h-[3rem] min-w-[3rem] min-h-[3rem] invert group-hover:invert-0 transition-all"
                  : "w-[3rem] h-[3rem] min-w-[3rem] min-h-[3rem]"
              }
            />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="min-w-[20rem] gap-0 rounded-none"
          align="end"
        >
          <DropdownMenuGroup>
            <DropdownMenuItem
              className="rounded-none focus:!bg-transparent focus:!text-current ring-0 outline-none px-[.5rem] py-0 opacity-60 hover:opacity-100 transition-opacity border-b border-b-black/10"
              onClick={() => setIsOpen(false)}
            >
              <Link
                href="/shop"
                className="w-full block px-[1rem] py-[2rem] text-[2rem] text-black/90"
              >
                HOME
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem
              className="rounded-none focus:!bg-transparent focus:!text-current ring-0 outline-none px-[.5rem] py-0 opacity-60 hover:opacity-100 transition-opacity border-b border-b-black/10"
              onClick={() => setIsOpen(false)}
            >
              <Link
                href="/shop/all"
                className="w-full block px-[1rem] py-[2rem] text-[2rem] text-black/90"
              >
                SHOP
              </Link>
            </DropdownMenuItem>
            <DropdownMenuItem
              className="rounded-none focus:!bg-transparent focus:!text-current ring-0 outline-none px-[.5rem] py-0 opacity-60 hover:opacity-100 transition-opacity border-b border-b-black/10"
              onClick={() => setIsOpen(false)}
            >
              <Link
                href="/shop/support"
                className="w-full block px-[1rem] py-[2rem] text-[2rem] text-black/90"
              >
                SUPPORT
              </Link>
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
